export default "__VITE_ASSET__Cty0kaym__"